// extracted by mini-css-extract-plugin
module.exports = {"root":"HotelSearchBox_root__34hI7","closeButton":"HotelSearchBox_closeButton__3iWyp"};